import {NewsState} from './news.state';
import {DirectionDTO} from '../../../../openapi/agrarinformationen-openapi';


export const newsStateInitial: NewsState = {
  newsIds: [],
  totalElements: 0,
  pageableDto: {
    size: 10,
    number: 0,
    property: ['createdAt'],
    direction: [DirectionDTO.Desc],
  },
  loading: false,
  loaded: false,
}
